import * as EventListener from "../../common/helpers/event-listener";

const showCurrency = () => {
    EventListener.click("currency-button", (button) => {
        const currencyDropdown = document.querySelector(".currency-dropdown");
        const hiddenClass = "hidden";

        if (currencyDropdown.classList.contains(hiddenClass)) {
            currencyDropdown.classList.remove(hiddenClass);
            document.addEventListener("click", clickCurrencyOutside);
        } else {
            currencyDropdown.classList.add(hiddenClass);
            document.removeEventListener("click", clickCurrencyOutside);
        }

        button.disabled = false;
    });
};

const clickCurrencyOutside = (event) => {
    const blockClass = "currency-dropdown";
    const hiddenClass = "hidden";
    const block = document.querySelector("." + blockClass);

    if (block) {
        if (event.target.classList.contains(blockClass)) {
            return;
        }

        if (!block.classList.contains(hiddenClass)) {
            block.classList.add(hiddenClass);

            document.removeEventListener("click", clickCurrencyOutside);
        }
    }
};

let openedSubMenu = null;

const showNavMenu = () => {
    const navMenu = document.querySelector(".header-nav");
    const openedClass = "show";

    if (navMenu.classList.contains(openedClass)) {
        navMenu.classList.remove(openedClass);

        if (openedSubMenu) {
            openedSubMenu.classList.remove(openedClass);
            openedSubMenu = null;
        }
    } else {
        navMenu.classList.add(openedClass);
    }
};

const clickShowNavMenu = () => {
    EventListener.click("menu-toggle", (button) => {
        showNavMenu();
        button.disabled = false;
    });
};

const clickCloseNavMenu = () => {
    EventListener.click("menu-toggle-close", (button) => {
        showNavMenu();
        button.disabled = false;
    });
};

const showSubMenu = (button) => {
    const navMenu = document.querySelector(".header-nav");
    const subMenu = document.getElementById(button.dataset.submenu);
    const openedClass = "show";

    if (subMenu.classList.contains(openedClass)) {
        subMenu.classList.remove(openedClass);
        openedSubMenu = null;
    } else {
        subMenu.classList.add(openedClass);
        navMenu.scrollTo({ top: 0, behavior: "smooth" });
        openedSubMenu = subMenu;
    }
};

const clickShowSubMenu = () => {
    EventListener.click("sub-menu-button", (button) => {
        showSubMenu(button);
        button.disabled = false;
    });
};

const clickCloseSubMenu = () => {
    EventListener.click("sub-menu-button-close", (button) => {
        showSubMenu(button);
        button.disabled = false;
    });
};

showCurrency();
clickShowNavMenu();
clickCloseNavMenu();
clickShowSubMenu();
clickCloseSubMenu();
